import { Controller } from '@hotwired/stimulus'
import { PreviewClient } from 'api/preview_client'
import { FileAttacher, disablingSubmitButtonOnUpload } from 'api/file_attacher'
import dragDrop from 'drag-drop'
import { Confirmable, ConfirmableEvent } from 'mixins/confirmable'
class BoardCommentEditor extends Confirmable(Controller) {
  connect () {
    this.initConfirmableForms([this.formTarget.id])
    this.currentBody = this.bodyTarget.value
    this.client = new PreviewClient({ previewTarget: this.previewTarget, bodyTarget: this.bodyTarget })
    // NOTE: data-targetを指定するとBootstrapのtabの挙動が怪しくなる為、ここでは使用していない
    const formTab = this.selfTarget.querySelector('.js-form-tab')
    if (formTab === null) {
      throw new Error('No URL found')
    }
    this.formTab = formTab
    const previewTab = this.selfTarget.querySelector('.js-preview-tab')
    if (previewTab === null) {
      throw new Error('No previewTab found')
    }
    this.previewTab = previewTab
    this.fileAttacher = new FileAttacher({
      bodyTarget: this.bodyTarget,
      callback: disablingSubmitButtonOnUpload(this.submitTarget)
    })
    dragDrop(this.bodyTarget, (files) => {
      this.fileAttacher.uploadFiles(files, window)
    })
    this.uploadButtonTarget.disabled = false
    if (this.selfTarget.dataset.commentId === undefined) {
      this.cancelButtonTarget.style.display = 'none'
      this.cancelButtonPreviewTarget.style.display = 'none'
    }
    this.updateCheering(this.selfTarget.dataset.cheering === 'true')
  }

  pasteClipboardData (e) {
    if (e.clipboardData.types.indexOf('Files') > -1) {
      this.fileAttacher.uploadFiles(Array.from(e.clipboardData.files), window)
      e.preventDefault()
    }
  }

  focusPreview () {
    this.updatePreview()
    this.previewTab.focus()
  }

  switchTab (e) {
    if (e.code === 'KeyP' && e.shiftKey && (e.ctrlKey || e.metaKey)) {
      e.preventDefault()
      if (this.formTab.classList.contains('active')) {
        this.updatePreview()
        this.previewTab.click()
        this.previewTab.focus()
      } else {
        this.formTab.click()
        this.formTab.addEventListener('shown.bs.tab', () => {
          this.bodyTarget.focus()
        })
      }
    }
  }

  clickFileUploadButton (e) {
    e.preventDefault()
    this.filesTarget.click()
  }

  changeFiles () {
    const files = this.filesTarget.files
    if (files === null) {
      throw new Error('No files found')
    }
    this.fileAttacher.uploadFiles(Array.from(files), window)
  }

  toggle () {
    if (this.selfTarget.querySelector('.comment-form__comment')?.classList.contains('d-none')) {
      this.close()
    } else {
      this.open()
    }
  }

  open () {
    // NOTE: _comment_form.html.haml で新規作成時・編集時のどちらかでしか
    //       利用されない要素はtargetではなくクラス指定にしている
    const comment = this.selfTarget.querySelector('.comment-form__comment')
    const editor = this.selfTarget.querySelector('.js-comment-editor')
    if (comment) comment.classList.add('d-none')
    if (editor) editor.classList.remove('d-none')
    this.editIconTarget.classList.add('comment-form__editing')
  }

  close () {
    // NOTE: _comment_form.html.haml で新規作成時・編集時のどちらかでしか
    //       利用されない要素はtargetではなくクラス指定にしている
    const comment = this.selfTarget.querySelector('.comment-form__comment')
    const editor = this.selfTarget.querySelector('.js-comment-editor')
    if (comment) comment.classList.remove('d-none')
    if (editor) editor.classList.add('d-none')
    this.editIconTarget.classList.remove('comment-form__editing')
    this.bodyTarget.value = this.currentBody
    this.formTarget.dispatchEvent(new Event(ConfirmableEvent.reset))
  }

  updatePreview () {
    this.previewTarget.innerHTML = ''
    this.client.call(100)
  }

  updateCheering (state) {
    if (!this.hasCheeringMarkTarget) { return }
    // TODO: stateに応じて「応援コメント」を表示・非表示を切り替える
    if (state) {
      this.cheeringMarkTarget.classList.remove('d-none')
    } else {
      this.cheeringMarkTarget.classList.add('d-none')
    }
  }
}
BoardCommentEditor.targets = ['self', 'preview', 'body', 'files', 'submit',
  'uploadButton', 'cancelButton', 'cancelButtonPreview',
  'editIcon', 'form', 'cheering', 'cheeringMark', 'cheeringNotice']
export default BoardCommentEditor
